<template>
  <v-dialog
    v-if="value"
    :value="value"
    @input="$emit('input', $event)"
    width="75vw"
    max-width="1200px"
    persistent
  >
    <v-card>
      <v-card-title>
        <span class="headline">案件予算削除エラー</span>
      </v-card-title>
      <div v-if="campaignList.length !== 0 && campaignList !== undefined">
        <v-card-text>
          以下のキャンペーンに設定されているキャンペーン予算が、この案件予算に紐づいているため、案件予算を削除できません。
        </v-card-text>
        <v-card-text v-for="(campaign, index) in campaignList" :key="index"
          >・{{ campaign.name }}（{{ campaign.anLineItemId }}）
        </v-card-text>
      </div>
      <v-card-text v-else
        >案件予算の削除に失敗しました。詳しくはお問い合わせください。</v-card-text
      >

      <v-card-actions>
        <v-spacer />
        <v-btn @click="close" color="primary">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteErrorModal',
  props: {
    value: Boolean,
    campaignList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
  },
}
</script>

<style></style>
